import api from '../api'
import { endpoints } from '../apiCommons'

export const login = async (sGuidLogin) => {
  return api.get(endpoints.login, { params: { sGuidLogin } }).then((res) => {
    api.defaults.headers.common['token'] = sGuidLogin
    return res
  })
}
